import {ReactComponent as Uk} from "../../../../img/categories/delivery/1.svg";
import {ReactComponent as Polt} from "../../../../img/categories/delivery/2.svg";
import {ReactComponent as Safe} from "../../../../img/categories/delivery/3.svg";
import {ReactComponent as Garan} from "../../../../img/categories/delivery/4.svg";
import s from "../product.module.css";

const ProductTabDelivery = () => {
    return (
        <div className={s.tabDelivery}>
            <div className={s.deliveryInfo}>
                <div>
                    <Uk/>
                    <h3>ДОСТАВКА ПО УКРАИНЕ </h3>
                </div>
                <p>При заказе на сумму от 1500 грн. и полной предоплате - предоставляем бесплатную доставку по Украине.
                    Обратите внимание! Бесплатной является только доставка товара. Дополнительные услуги транспортных
                    компаний (наложенный платеж, адресная доставка и т.д) оплачивается покупателем и рассчитывается по
                    тарифам перевозчиков.
                </p>
            </div>
            <div className={s.deliveryInfo}>
                <div>
                    <Polt/>
                    <h3>ДОСТАВКА ПО ПОЛТАВЕ</h3>
                </div>
                <p>Бесплатно предоставляем курьерскую доставку по городу Полтава, при заказе на сумму от 800 гривен.
                </p>
            </div>
            <div className={s.deliveryInfo}>
                <div>
                    <Safe/>
                    <h3>БЕЗОПАСНАЯ ОПЛАТА</h3>
                </div>
                <p>Возможна оплата с помощью наложенного платежа (оплата на отделении транспортной компании) или
                    переводом денежных средств на банковскую карту.</p>
            </div>
            <div className={s.deliveryInfo}>
                <div>
                    <Garan/>
                    <h3>ГАРАНТИИ</h3>
                </div>
                <p>При обнаружении заводского брака, несоответствии расцветок либо же каких либо других погрешностей - в
                    течении 14 рабочих дней обмениваем продукцию на соответствующую,, либо же возвращаем 100% суммы,
                    оплаченной Вами.
                </p>
            </div>
        </div>
    )
}


export default ProductTabDelivery;